import {
  CountBar,
  divWithStyle,
  keyframes,
  lineageBarHeight,
  lineageBarMaxWidth,
} from '@tableau/data-catalog-shared';
import * as React from 'react';
import { Formatters, Messages } from '../../../gen-src/Localize';

const fadeInAnimation = keyframes({
  '0%': { opacity: 0 },
  '100%': { opacity: 1 }
});

const BarContainer = divWithStyle('BarContainer', {
  borderRadius: '1px',
  animationName: fadeInAnimation,
  animationDuration: '250ms',
  animationTimingFunction: 'ease-in',
});

export interface LineageFilteredBarProps {
  readonly unfilteredCount: number | null; // TODO: Burn this nullability with fire once we have a proper loading state for the lineage
  readonly filteredCount: number | null; // TODO: Burn this nullability with fire once we have a proper loading state for the lineage
}

export function LineageFilteredBar(props: LineageFilteredBarProps): JSX.Element | null {
  const unfilteredCount = props.unfilteredCount;
  const filteredCount = props.filteredCount;
  if (unfilteredCount != null && filteredCount != null) {
    const barTitle = Messages.XofN({
      countX: Formatters.formatCount(filteredCount),
      countN: Formatters.formatCount(unfilteredCount)
    });
    return (
      <BarContainer title={barTitle}>
        <CountBar
          maxValue={props.unfilteredCount}
          currentValue={props.filteredCount}
          maxWidth={lineageBarMaxWidth}
          height={lineageBarHeight}
          colorPaletteName='lineage'
          shouldAnimateBarWidth={true}
        />
      </BarContainer>
    );
  } else {
    return <div style={{ height: lineageBarHeight }} />;
  }
}
